export const MAX_CALENDAR_NO_WRAP = 4;
